import { privacyPath, termsPath } from "~/common/paths"
import { Logo } from "../logo"
import { FooterLink, Copyright, AppDownload, Stars } from "./shared-footer-components"
import { getMetaContent } from "~/common/get-meta-content"

export function MobileBottomFooter() {
  return (
    <div className="md:hidden">
      <div className="flex items-center justify-center pt-12">
        <Stars />
      </div>

      <div className="flex flex-row items-center justify-center pt-6">
        <AppDownload />
      </div>

      <div className="flex flex-col items-center justify-center pt-6">
        <FooterLink href={`mailto:${getMetaContent<string>("SUPPORT_EMAIL")}`}>
          Contact us
        </FooterLink>
        <FooterLink to={termsPath({})}>Terms of use</FooterLink>
        <FooterLink to={privacyPath({})}>Privacy policy</FooterLink>
      </div>

      <div className="flex flex-col items-center justify-center pb-16 pt-8">
        <Logo />
        <Copyright />
      </div>
    </div>
  )
}
